angular.module('app').directive('arrowLine', function () {
  return {
    restrict: 'E',
    templateUrl: 'app/directives/arrow-line/arrowLine.html',
  }
});
